import { t } from 'i18next';
import { useState, useEffect, useRef } from 'react';
import Joyride from 'react-joyride';
import { Tooltip } from './Steps';
import { useStatusContext } from 'context/control-state';
import { usePointOfSale } from 'context';
import { isZettiFormat } from 'utils/pointOfSale';
import { newNormalOnboarding } from './array';
import { useUser } from 'utils/hooks';
import { useRouter } from 'next/router';
import { showWalkthough } from 'api';
import { EX8057 } from 'config/flags';
import { showWalkthroughKey } from 'utils/showWalkthroughKey/showWalkthroughKey';

const NewWalkthrough = () => {
    const router = useRouter();
    const { pathname, query } = router;
    const { clientId, posId } = query;

    const joyrideRef = useRef(null);
    const { user } = useUser({});
    const {
        setCounterStep,
        setIsTourOpen,
        setDisplayModalOnBoarding,
        hideSuggestionPDV,
        setContinueStatus,
    } = useStatusContext();

    const [joyrideState, setJoyrideState] = useState({
        run: false,
        steps: newNormalOnboarding(),
    });

    const { run, steps } = joyrideState;
    const [stepIndex, setStepIndex] = useState(0);
    const [showWalkthrough, setShowWalkthrough] = useState(null); // <- NUEVO

    const { pointOfSale } = usePointOfSale();
    const isZetti = isZettiFormat(pointOfSale);

    // Llamada al endpoint y actualización del estado
    const showWalkthroughFreeTrial = async () => {
        try {
            const response = await showWalkthough();
            setShowWalkthrough(response.data.show_walkthrough_free_trial);
        } catch (error) {
            console.error('Error fetching walkthrough status:', error);
            setShowWalkthrough(false);
        }
    };

    // Llamar al endpoint una sola vez al montar
    useEffect(() => {
        if (!EX8057) {
            showWalkthroughFreeTrial();
        }
    }, []);

    useEffect(() => {
        if (EX8057) {
            setShowWalkthrough(showWalkthroughKey(user));
        }
    }, [user]);

    // Este useEffect se ejecuta solo después de tener showWalkthrough definido
    useEffect(() => {
        if (showWalkthrough === null) return; // aún cargando

        const validRoute =
            pathname === '/[clientId]/efficient-purchase/[posId]' || pathname === '/[clientId]/efficient-purchase/';

        const newRun = showWalkthrough && validRoute;

        if (newRun) {
            setStepIndex(0);
        }

        setJoyrideState((prev) => ({
            ...prev,
            run: newRun,
        }));
    }, [showWalkthrough, pathname]);

    const handleJoyrideCallback = (data) => {
        let finish = false;
        const { action, index, type, status } = data;

        if (action === 'close') {
            finish = true;
            setStepIndex(0);
            setJoyrideState((prev) => ({ ...prev, run: false }));
        }
        if (action === 'prev' && type === 'step:after' && !finish) {
            setStepIndex(index - 1);
        }
        if (action === 'next' && type === 'step:after' && !finish) {
            setStepIndex(index + 1);
        }
        if (action === 'close' && type === 'tour:status') {
            setStepIndex(0);
            setContinueStatus(status);
            setJoyrideState((prev) => ({ ...prev, run: false }));
        }
    };

    const handleStepActions = (obj) => {
        if (obj.action === 'close' || obj.action === 'stop') {
            setCounterStep('body');
            setIsTourOpen(false);
            if (obj.step.target === '#step4') {
                localStorage.setItem('checkOnboarding', 'true');
            }
        } else {
            setCounterStep(obj.step.target);
        }
    };

    // Si aún no se sabe si hay que mostrar el walkthrough, no renderizar nada
    if (showWalkthrough === null) return null;

    return (
        <Joyride
            //@ts-ignore
            tooltipComponent={Tooltip}
            //@ts-ignore
            steps={steps}
            run={run}
            stepIndex={stepIndex}
            callback={(obj) => {
                handleJoyrideCallback(obj);
                handleStepActions(obj);
            }}
            continuous
            disableOverlayClose
            disableScrollParentFix
            disableScrolling
            spotlightClicks={false}
            disableOverlay={false}
            styles={{
                options: {
                    overlayColor: 'transparent',
                    primaryColor: 'blue',
                    textColor: '#004a14',
                    width: 382,
                    zIndex: 99999,
                },
            }}
            ref={joyrideRef}
        />
    );
};

export default NewWalkthrough;
